import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Button, Card, message, Modal, Popconfirm, Select, Table } from "antd";
import axios from "../services/axios";
import ReactLoading from "react-loading";
import isConsultant from "../services/isConsultant";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const AddInterviewStatus = (props) => {
  const [status, setStatus] = useState();
  const [inputStatus, setInputStatus] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [inputStatusError, setInputStatusError] = useState("");
  const [inputReasonError, setInputReasonError] = useState("");
  const [inputEditStatusError, setInputEditStatusError] = useState("");
  const [inputEditReasonError, setInputEditReasonError] = useState("");
  const [selectStatusError, setSelectStatusError] = useState("");
  const [load, setLoad] = useState(false);
  const [reason, setReason] = useState("");
  const [selectStatus, setSelectStatus] = useState("");
  const [tableData, setTableData] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [canCreateStatus, setCanCreateStatus] = useState(false);
  const [canCreateStatusReason, setCanCreateStatusReason] = useState(false);
  const [canEditStatus, setCanEditStatus] = useState(false);
  const [canDeleteStatus, setCanDeleteStatus] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const createStatusAllowed = await checkPermission(
        userRole,
        "interview_status_module",
        "create_status"
      );
      const createStatusReasonAllowed = await checkPermission(
        userRole,
        "interview_status_module",
        "create_status_reason"
      );
      const editStatusAllowed = await checkPermission(
        userRole,
        "interview_status_module",
        "edit_status"
      );
      const deleteStatusAllowed = await checkPermission(
        userRole,
        "interview_status_module",
        "delete_status"
      );

      setCanCreateStatus(createStatusAllowed);
      setCanCreateStatusReason(createStatusReasonAllowed);
      setCanEditStatus(editStatusAllowed);
      setCanDeleteStatus(deleteStatusAllowed);
    } catch (err) {
      console.error("Error checking permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (val, record) => {
        return (
          <Select
            placeholder="Select Reason"
            onChange={(value) => handleOnClickEditReason(value)}
            style={{ width: 200 }}
          >
            {record.reason?.map((ele) => {
              return (
                <Select.Option value={ele?._id}>
                  {ele?.parameterName}
                </Select.Option>
              );
            })}
          </Select>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
      fixed: "right",
      key: "action",
      render: (val, record) => {
        return (
          <div style={{ display: "flex" }}>
            {canEditStatus && (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                handleEdit(record._id);
              }}
            >
              <i class="fa fa-edit"></i> Edit
            </button>
            )}
            {canDeleteStatus && (
            <Popconfirm
              placement="right"
              title="Are you sure to delete this task?"
              onConfirm={() => {
                handleDeleteStatus(record);
              }}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{
                  display: "block",
                  marginLeft: "1.2rem",
                }}
              >
                X
              </Button>
            </Popconfirm>
            )}
          </div>
        );
      },
    },
  ];

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);

    setInputReasonError("");
    setInputEditStatusError("");
    setInputEditReasonError("");
    setSelectStatusError("");
  };

  const success = (e) => {
    if (e === "reasonUpdated") {
      message.success("Status mapped, Successfully", 5);
    } else if (e === "reasonEditted") {
      message.success("Reason Editted, Successfully", 5);
    } else if (e === "reasonDeleted") {
      message.success("Reason Deleted, Successfully", 5);
    } else if (e === "StatusDeleted") {
      message.success("Status Deleted, Successfully", 3);
    } else if (e === "statusSubmit") {
      message.success("Status Submitted, Successfully", 3);
    } else {
      message.success("status Editted, Successfully", 5);
    }
  };

  useEffect(() => {
    //SELECT REASON DATA
    getStatusMasterFunction();
    //TABLE DATA
    statusParametersMasterFunction();
  }, [refresh]);

  const getStatusMasterFunction = () => {
    axios
      .get("/statusMaster", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data.statusMaster;
        setStatus(data);
      });
  };

  const statusParametersMasterFunction = () => {
    axios
      .get("/statusParametersMaster", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        let rows = [];

        for (let i = 0; i < data.length; i++) {
          rows.push({
            key: i + 1,
            status: data[i].name,
            reason: data[i].parameterList,
            data: data[i],
            _id: data[i]?._id,
          });
        }
        setTableData(rows);
      });
  };

  //STATUS MODULE
  const handleInputStatus = (e) => {
    setRefresh(false);
    setInputStatusError("");
    setInputStatus(e.target.value);
  };

  const handleInputStatusSubmit = (e) => {
    e.preventDefault();
    if (inputStatus !== "" && inputStatus.trim().length !== 0) {
      setLoad(true);
      axios
        .post(
          "/statusMaster",
          { name: inputStatus.replace(/\s{2,}/g, " ").trim(), status: true },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          const data = res.data.statusMaster;
          setRefresh(true);
          setLoad(false);
          success("statusSubmit");
        });
      setInputStatus("");
    } else {
      setInputStatusError("Status is required");
    }
  };

  //REASON MODULE
  const handleSelectStatus = (e) => {
    setSelectStatusError("");
    setSelectStatus(e.target.value);
    setRefresh(false);
  };

  const handleInputReason = (e) => {
    setInputReasonError("");
    setReason(e.target.value);
    setRefresh(false);
  };

  const handleSubmitReason = (e) => {
    e.preventDefault();
    if (selectStatus === "") {
      setSelectStatusError("status is required");
    } else if (reason === "" || reason.trim().length === 0) {
      setInputReasonError("Reason is required");
    } else {
      setLoad(true);
      axios
        .post(
          "/statusParametersMaster",
          {
            statusMaster: selectStatus,
            parameterName: reason.replace(/\s{2,}/g, " ").trim(),
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          const data = res.data.statusMaster;
          setRefresh(true);
          setLoad(false);
          success("reasonUpdated");
        });
      setSelectStatus("");
      setReason("");
    }
  };

  //EDIT STATUS MODULE
  const [editData, setEditData] = useState([]);
  const [editStatus, setEditStatus] = useState("");
  const [editStatusId, setEditStatusId] = useState("");

  const handleEdit = (id) => {
    const data = tableData?.filter((ele) => {
      return id === ele._id;
    });
    setEditData(data[0].reason);
    setEditStatus(data[0].status);
    setEditStatusId(data[0]._id);
    showModal();
  };

  const handleInputEditStatus = (e) => {
    setInputEditStatusError("");
    setEditStatus(e.target.value);
    setRefresh(false);
  };

  const handleSaveEdittedStatus = (e) => {
    if (editStatus === "" || editStatus.trim().length === 0) {
      setInputEditStatusError("Status is required");
    } else {
      setLoad(true);
      axios
        .put(
          "/statusMaster/" + editStatusId,
          {
            statusName: editStatus.replace(/\s{2,}/g, " ").trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          setRefresh(true);
          setLoad(false);
          success("statusEditted");
        });
    }
  };

  //EDIT REASON MODULE
  const [editReason, setEditReason] = useState("");
  const [editReasonId, setEditReasonId] = useState("");
  const [statusMasterId, setStatusMasterId] = useState("");

  const handleOnClickEditReason = (_id) => {
    const obj = editData.filter((ele) => {
      return _id === ele._id;
    });
    setEditReason(obj[0]?.parameterName || "");
    setEditReasonId(obj[0]?._id || "");
    setStatusMasterId(obj[0]?.statusMaster || "");
  };

  const handleInputEditReason = (e) => {
    setInputEditReasonError("");
    setEditReason(e.target.value);
    setRefresh(false);
  };

  const handleSubmitEdittedReason = (e) => {
    e.preventDefault();
    if (editReason === "" || editReason.trim().length === 0) {
      setInputEditReasonError("Reason is required");
    } else {
      setLoad(true);
      const newArr = editData.map((obj) => {
        if (obj._id === editReasonId) {
          return { ...obj, parameterName: editReason };
        }
        return obj;
      });
      setEditData(newArr);

      axios
        .put(
          "/statusParametersMaster/" + editReasonId,
          {
            statusMaster: statusMasterId,
            parameterName: editReason.replace(/\s{2,}/g, " ").trim(),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          },
        )
        .then((res) => {
          setLoad(false);
          setEditData(newArr);
          setRefresh(true);
          setEditReason("");
          success("reasonEditted");
        });
    }
  };

  const handleDeleteStatus = (e) => {
    setLoad(true);
    setRefresh(false);
    axios
      .delete("/statusMaster/" + e._id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setRefresh(true);
        setLoad(false);
        success("StatusDeleted");
      });
  };

  const cancel = (e) => {
    message.error("Click on No");
  };

  const handleDeleteReason = (e) => {
    if (editReason === "" || editReason.trim().length === 0) {
      setInputEditReasonError("Reason is required");
    } else {
      setRefresh(false);
      const newEditData = editData.filter((ele) => {
        return editReasonId !== ele._id;
      });
      setEditData(newEditData);

      axios
        .delete("/statusParametersMaster/" + editReasonId, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        })
        .then((res) => {
          const data = res.data;
          success("reasonDeleted");
          setEditReason("");
          setRefresh(true);
        });
    }
  };

  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Add Interview Status">
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          <div className="row mb-4">
            <div className="col-lg-4">
              <div>
                <Card title="Add Status" className="border">
                  <div className="form-group mb-0">
                    <input
                      placeholder="Enter Status"
                      value={inputStatus}
                      type="text"
                      onChange={handleInputStatus}
                      class="form-control"
                      id="usr"
                    />
                    {inputStatusError && (
                      <div
                        className="text-danger"
                        style={{ marginTop: 5 + "px" }}
                      >
                        {inputStatusError}
                      </div>
                    )}
                    {canCreateStatus && (
                    <button
                      onClick={handleInputStatusSubmit}
                      style={{
                        marginTop: "15px",
                      }}
                      className="btn btn-primary"
                    >
                      Create
                    </button>
                    )}
                  </div>
                </Card>
              </div>
              <div style={{ marginTop: "30px" }}>
                <Card title="Add Status Reason" className="border">
                  <div className="form-group mb-0">
                    <select
                      id="FormType"
                      className="mb-2 form-control "
                      onChange={handleSelectStatus}
                      value={selectStatus}
                    >
                      <option value="" selected="true">
                        Select Status
                      </option>
                      {status?.map((ele) => {
                        return <option value={ele._id}>{ele.name}</option>;
                      })}
                    </select>
                    {selectStatusError && (
                      <div
                        className="text-danger"
                        style={{ marginTop: 5 + "px" }}
                      >
                        {selectStatusError}
                      </div>
                    )}
                    <input
                      style={{
                        marginTop: "15px",
                      }}
                      placeholder="Enter Reason"
                      type="text"
                      class="form-control"
                      id="usr"
                      onChange={handleInputReason}
                      value={reason}
                    />
                    {inputReasonError && (
                      <div
                        className="text-danger"
                        style={{ marginTop: 5 + "px" }}
                      >
                        {inputReasonError}
                      </div>
                    )}
                    {canCreateStatusReason && (
                    <button
                      onClick={handleSubmitReason}
                      style={{
                        marginTop: "15px",
                      }}
                      className="btn btn-primary"
                    >
                      Create
                    </button>
                    )}
                  </div>
                </Card>
              </div>
            </div>

            {/* TABLE FOR DISPLAYING STATUS DATA */}
            <div className="col-lg-8">
              <Card className="border">
                <Table
                  dataSource={tableData}
                  columns={columns}
                  scroll={{ x: true }}
                  style={{ whiteSpace: "pre" }}
                  pagination={true}
                  size="small"
                />
              </Card>
            </div>
          </div>

          {/* EDIT FUNCTIONALITY MODAL */}
          <Modal
            title="Edit"
            width={600}
            visible={isModalVisible}
            footer={[
              <>
                <button className="btn btn-secondary" onClick={handleCancel}>
                  Cancel
                </button>
              </>,
            ]}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <div className="form-group mb-0">
              <label>Edit Status</label>
              <div className="d-flex justify-content-between align-items-center gap-3">
                <div className="d-flex flex-column w-100">
                  <input
                    placeholder="Enter Status"
                    value={editStatus}
                    type="text"
                    onChange={handleInputEditStatus}
                    class="form-control"
                    id="usr"
                  />
                </div>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleSaveEdittedStatus}
                >
                  Save
                </button>
              </div>
              {inputEditStatusError && (
                <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                  {inputEditStatusError}
                </div>
              )}
            </div>
            {editData?.length > 0 && (
              <div className="form-group mb-0">
                <label className="my-2">Edit Reason</label>
                <div className="d-flex w-100">
                  <select
                    id="FormType"
                    className="mb-2 form-control"
                    onChange={(e) => handleOnClickEditReason(e.target.value)}
                    value={editReasonId}
                  >
                    <option value="" selected>
                      Select reason
                    </option>
                    {editData?.map((list) => {
                      return (
                        <option value={list._id}>{list.parameterName}</option>
                      );
                    })}
                  </select>
                </div>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex flex-column w-100">
                    <input
                      placeholder="Enter Status"
                      value={editReason}
                      type="text"
                      onChange={handleInputEditReason}
                      class="form-control"
                      id="usr"
                    />
                  </div>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={handleSubmitEdittedReason}
                  >
                    Save
                  </button>
                  <Popconfirm
                    title="Are you sure to delete this task?"
                    onConfirm={() => {
                      handleDeleteReason();
                    }}
                    onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <button
                      // onClick={handleDeleteStatus}
                      className="btn btn-danger btn-sm"
                    >
                      X
                    </button>
                  </Popconfirm>
                </div>
                {inputEditReasonError && (
                  <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                    {inputEditReasonError}
                  </div>
                )}
              </div>
            )}
          </Modal>
        </Dashboard>
      )}
    </div>
  );
};

export default AddInterviewStatus;
